import { render } from "./TourGuideFee.vue?vue&type=template&id=70f6b09c&scoped=true"
import script from "./TourGuideFee.vue?vue&type=script&lang=js"
export * from "./TourGuideFee.vue?vue&type=script&lang=js"

import "./TourGuideFee.vue?vue&type=style&index=0&id=70f6b09c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70f6b09c"

export default script